import { InteractionsAnim } from 'animations/Interactions'
import styled from 'styled-components'
const { textClick } = InteractionsAnim()

interface BUTTON_STYLED_PROPS {
  textColor?: any
  anim?: boolean
  borderColor?: string
  innerBackground?: string
  focusColor?: string
}
export const OperationsWrapper = styled.div<BUTTON_STYLED_PROPS>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  p {
    font-size: 18px;
    color: ${({ textColor }) => textColor};
  }
`
export const ActionButtonsWrapper = styled.div<BUTTON_STYLED_PROPS>`
  width: 100%;
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
  p {
    margin-top: 16px;
    cursor: pointer;
    ${({ anim }) => anim && textClick};
  }
`
export const StakeWrapper = styled.div<BUTTON_STYLED_PROPS>`
  width: 100%;
  font-size: 18px;
  text-transform: uppercase;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin-top: 11px;
  p {
    margin-top: 16px;
  }
`
export const InputBox = styled.div<BUTTON_STYLED_PROPS>`
  height: 56px;
  width: 140px;
  font-size: 18px;
  text-align: center;
  border-radius: 100px;
  display: flex;
  align-items: center;
  border: ${({ borderColor }) =>
    borderColor ? `3px solid ${borderColor}` : 'none'};
  background: ${({ innerBackground }) => innerBackground || 'transparent'};
  color: #ffb000;
  position: relative;
  padding-left: 23px;
  ::placeholder {
    color: #ffb000;
  }
  :focus {
    background: ${({ focusColor }) => focusColor || 'transparent'};
  }
  span {
    /* position: absolute; */
    /* left: 23px; */
    height: 100%;
    width: 16px;
    display: flex;
    align-items: center;
  }
  svg {
    width: 16px;
    height: 16px;
  }
`
